// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { VideoFragmentDoc } from '../video.fragment.generated';
export const ComponentVideoFragmentDoc = gql`
    fragment componentVideo on ComponentVideo {
  video {
    ...video
  }
  videoWidth: width
}
    ${VideoFragmentDoc}`;